import { DriverTableRoute } from "@types_def/models/driver.types";
import { getDriverTableRouteAttributes } from "@utils/functions/Delivery/DriverTable/driverTableAttributes";

export const driverTableRoutes = {
  "accepted-requests": getDriverTableRouteAttributes(DriverTableRoute.ACCEPTED_REQUESTS),
  "waiting-requests": getDriverTableRouteAttributes(DriverTableRoute.WAITING_REQUESTS),
  "refused-requests": getDriverTableRouteAttributes(DriverTableRoute.REFUSED_REQUESTS),
  "disabled-drivers": getDriverTableRouteAttributes(DriverTableRoute.DISABLED_DRIVERS),
};
